import intl from 'react-intl-universal'
import { store } from '../../redux/store';
import authActions from '../../redux/auth/actions';

class NetworkError {

    constructor(error) {
        this.error = error;
        store.dispatch(authActions.logout());
        this.message = intl.get("err.network") + " " + intl.get("err.login.again");
    }
}
NetworkError.prototype.toString = function () {
    return this.error;
}


//export default connect(null, { logout })(NetworkError);
export default NetworkError;